import './style.css';

import React, { useState } from 'react';
import { t, useLocalization } from '../../l10n/l10n';
import { useEContext } from '../../EContext';
import { Button, Modal } from '@economic/gaudi';
import VismaConnectVerifyInformationDialog from '../VismaConnectVerifyInformationDialog';
import { Link, Redirect } from 'react-router-dom';
import iconVismaConnectJoin from './join-vc-icon.svg';

function JoinPopupCloseLink({ closeLinkText, onClick, shouldRender }) {
    if (!shouldRender) {
        return null;
    }

    return (
        <span id="close-link">
            <a onClick={onClick} href="#">
                {closeLinkText}
            </a>
        </span>
    );
}

function JoinPopupLogoutLink({ logoutLinkText, shouldRender }) {
    if (!shouldRender) {
        return null;
    }

    return (
        <div className="vismaconnect-popups vismaconnect-join-link">
            <Link to="/logout">{logoutLinkText}</Link>
        </div>
    );
}

enum States {
    Join = 1,
    Verify = 2,
}

export default function VismaConnectJoinDialog() {
    const loadingTexts = useLocalization(textIds);
    const { identity } = useEContext();
    const [show, setShow] = useState(true);
    const [state, setState] = useState(States.Join);

    if (loadingTexts || !identity || !show) {
        return null;
    }

    if (!identity.session.vismaConnectPopups) {
        return null;
    }

    const {
        vismaConnectPopups: { joinPopupVariant },
    } = identity.session;

    const { isDeveloper } = identity.currentAgreement;

    if (joinPopupVariant < 1 || identity.currentAgreement.showGettingStarted) {
        return null;
    }

    var enforcePopup = false;
    if (joinPopupVariant === 4) {
        enforcePopup = true;
    }

    var titleTextId = `SIGNUP_CONNECT_MODAL_TITLE_${joinPopupVariant}`;
    var contentTextId = `SIGNUP_CONNECT_MODAL_CONTENT_${joinPopupVariant}`;

    function onVerificationDone() {
        setShow(false);
    }

    function handlePopupClose() {
        setShow(false);
        if (enforcePopup) {
            return <Redirect to="/logout" />;
        }
    }

    if (state === States.Verify) {
        return (
            <VismaConnectVerifyInformationDialog
                enforcePopup={enforcePopup}
                displayNewsletter={!isDeveloper}
                isForInvite={false}
                firstName={identity.user.firstName}
                lastName={identity.user.lastName}
                email={identity.user.email}
                onDone={onVerificationDone}
            />
        );
    }

    return (
        <Modal visible={show} showCloseButton={false} hideOnEsc={!enforcePopup} hideOnClickOutside={false}>
            <div className="vismaconnect-popups vismaconnect-join">
                <JoinPopupCloseLink
                    closeLinkText={t`SIGNUP_CONNECT_MODAL_CANCEL`}
                    onClick={() => handlePopupClose()}
                    shouldRender={!enforcePopup}
                />
                <br />

                <h1>{t(titleTextId)}</h1>

                <img src={iconVismaConnectJoin} alt="" />

                <br />

                <p>{t(contentTextId)}</p>

                <Button appearance="primary" type="button" onClick={() => setState(States.Verify)}>
                    {t`SIGNUP_CONNECT_MODAL_CONFIRM`}
                </Button>

                <div className="vismaconnect-popups vismaconnect-join-link">
                    <a
                        href={
                            enforcePopup ? t`SIGNUP_CONNECT_MODAL_READ_MORE_URL_BLOCKED` : t`SIGNUP_CONNECT_MODAL_READ_MORE_URL`
                        }
                        target="_blank"
                        rel="noopener noreferrer">{t`SIGNUP_CONNECT_MODAL_READ_MORE`}</a>
                </div>

                <br />

                <JoinPopupLogoutLink logoutLinkText={t`SIGNUP_CONNECT_MODAL_LOGOFF`} shouldRender={enforcePopup} />
            </div>
        </Modal>
    );
}

const textIds = [
    'SIGNUP_CONNECT_MODAL_TITLE_1',
    'SIGNUP_CONNECT_MODAL_TITLE_2',
    'SIGNUP_CONNECT_MODAL_TITLE_3',
    'SIGNUP_CONNECT_MODAL_TITLE_4',
    'SIGNUP_CONNECT_MODAL_CONTENT_1',
    'SIGNUP_CONNECT_MODAL_CONTENT_2',
    'SIGNUP_CONNECT_MODAL_CONTENT_3',
    'SIGNUP_CONNECT_MODAL_CONTENT_4',
    'SIGNUP_CONNECT_MODAL_CANCEL',
    'SIGNUP_CONNECT_MODAL_CONFIRM',
    'SIGNUP_CONNECT_MODAL_LOGOFF',
    'SIGNUP_CONNECT_MODAL_READ_MORE',
    'SIGNUP_CONNECT_MODAL_READ_MORE_URL',
    'SIGNUP_CONNECT_MODAL_READ_MORE_URL_BLOCKED',
];
